module.exports = __webpack_public_path__ + "img/20220623154507402lyf.04d4f677.jpg";